import * as yup from "yup";
import { t } from "i18next";
import type { VerifySmsRequest } from "@/services/api";

export const getPhoneVerifySchema = () =>
  yup.object<VerifySmsRequest>().shape({
    code: yup.string().required(t("validation.required")),
  });
